import dotenv from 'dotenv'
dotenv.config()
const REACT_APP_BASE_API_URL = process.env.REACT_APP_BASE_API_URL || 'http://localhost:8080'
const REACT_APP_BACK_OFFICE_URL = process.env.REACT_APP_BACK_OFFICE_URL || 'http://locahost:5000'
const REACT_APP_TREASURE_HUNT_URL = process.env.REACT_APP_TREASURE_HUNT_URL ?? 'http://localhost:8080'
const REACT_APP_TEAM_BUILDING_URL = process.env.REACT_APP_TEAM_BUILDING_URL ?? 'http://localhost:8080'
const REACT_APP_FACEBOOK_APP_ID = process.env.REACT_APP_FACEBOOK_APP_ID || 'xxx'
const REACT_APP_FACEBOOK_REDIRECT_URL = process.env.REACT_APP_FACEBOOK_REDIRECT_URL || 'xxx'
const REACT_APP_LINE_APP_ID = process.env.REACT_APP_LINE_APP_ID || 'xxx'
const REACT_APP_LINE_REDIRECT_URL = process.env.REACT_APP_LINE_REDIRECT_URL || 'xxx'
const REACT_APP_GOOGLE_APP_ID = process.env.REACT_APP_GOOGLE_APP_ID || 'xxx'
const REACT_APP_GOOGLE_REDIRECT_URL = process.env.REACT_APP_GOOGLE_REDIRECT_URL || 'xxx'
const REACT_APP_APPLE_APP_ID = process.env.REACT_APP_APPLE_APP_ID || 'xxx'
const REACT_APP_APPLE_REDIRECT_URL = process.env.REACT_APP_APPLE_REDIRECT_URL || 'xxx'
const REACT_APP_BASEURL = process.env.REACT_APP_BASEURL || 'xxx'

export {
	REACT_APP_BASE_API_URL,
	REACT_APP_BACK_OFFICE_URL,
	REACT_APP_TREASURE_HUNT_URL,
	REACT_APP_TEAM_BUILDING_URL,
	REACT_APP_FACEBOOK_APP_ID,
	REACT_APP_FACEBOOK_REDIRECT_URL,
	REACT_APP_LINE_APP_ID,
	REACT_APP_LINE_REDIRECT_URL,
	REACT_APP_GOOGLE_APP_ID,
	REACT_APP_GOOGLE_REDIRECT_URL,
	REACT_APP_APPLE_APP_ID,
	REACT_APP_APPLE_REDIRECT_URL,
	REACT_APP_BASEURL
}
